/*
colors 1-3 go with black FG
color 4 goes with white FG
*/
export const colors = {
  white1: '#FFFFFF',
  white2: '#F7F5F1',
  white3: '#F2EFE9',
  white4: '#EBE6DB',
  white5: '#FDFCFB',
  yellow1: '#FCBE3D',
  yellow1_20: 'rgb(252,190,61, 0.20)',
  yellow1_50: 'rgb(252,190,61, 0.50)',
  yellow2: '#EDB02F',
  yellow3: '#D69C24',
  yellow4: '#B0852B',
  red1: '#EC6A6A',
  red2: '#E36666',
  red3: '#D15A5A',
  red4: '#C24646',
  green1: '#4AA462',
  green1_20: 'rgba(74, 164, 98, 0.20)',
  green1_50: 'rgba(74, 164, 98, 0.50)',
  green2: '#45995B',
  green3: '#429157',
  green4: '#367848',
  teal1: '#86A9AA',
  teal1_20: 'rgba(134, 169, 170, 0.20)',
  teal1_50: 'rgba(134, 169, 170, 0.50)',
  teal1_90: 'rgba(134, 169, 170, 0.9)',
  teal2: '#7B9B9C',
  teal3: '#6B8E8F',
  teal4: '#597778',
  black1: '#00000033',
  black2: '#00000080',
  black3: '#000000b3',
  black4: '#000',
};

export const darkComponentsTheme = {
  token: {
    colorTextBase: colors.white1,
  },
};

export const feedViewTheme = {
  components: {
    Layout: {
      headerBg: colors.white1,
      lightSiderBg: colors.white3,
    },
  },
};

export const feedCardFormTheme = {};

export const modalTheme = {
  token: {
    colorBorderSecondary: colors.black1,
  },
  components: {
    Modal: {
      contentBg: colors.white5,
      headerBg: colors.white5,
    },
    Input: {
      activeBg: colors.white1,
      hoverBg: colors.white1,
    },
  },
};

export const feedCardModalTheme = {
  token: {
    colorBorderSecondary: colors.black1,
    colorBgContainer: colors.white1,
  },
  components: {
    Modal: {
      contentBg: colors.white5,
      headerBg: colors.white5,
    },
  },
};

export const yellowButtonTheme = {
  token: {
    colorPrimary: colors.yellow2,
    colorPrimaryHover: colors.yellow1,
    colorPrimaryActive: colors.yellow4,
    colorText: colors.black4,
    colorTextLightSolid: colors.black4,
  },
  components: {
    Button: {
      defaultColor: colors.black4,
      primaryColor: colors.black4,
    },
  },
};

export const tealButtonTheme = {
  token: {
    colorPrimary: colors.teal4,
    colorPrimaryHover: colors.teal2,
    colorPrimaryActive: colors.teal3,
  },
};

export const redButtonTheme = {
  token: {
    colorPrimary: colors.red3,
    colorPrimaryHover: colors.red1,
    colorPrimaryActive: colors.red4,
  },
};

export const playButtonTheme = {
  token: {
    colorPrimary: colors.teal2,
    colorPrimaryHover: colors.teal1,
    colorPrimaryActive: colors.teal4,
    colorText: colors.black4,
    colorTextLightSolid: colors.black4,
  },
  components: {
    Button: {
      defaultColor: colors.black4,
      primaryColor: colors.black4,
    },
  },
};

export const antdTheme = {
  token: {
    colorPrimary: colors.green3,
    colorPrimaryHover: colors.green1,
    colorPrimaryActive: colors.green4,

    colorLink: colors.green4,
    colorLinkHover: colors.green2,
    colorLinkActive: colors.green4,

    colorFillContent: colors.white2,
    colorSplit: colors.white4,
    colorTextQuaternary: colors.black1,

    colorSuccess: colors.green4,
    colorInfo: colors.teal4,
    colorWarning: colors.yellow4,
    colorError: colors.red4,

    colorBgContainer: colors.white1,
    colorBgContainerDisabled: colors.white2,
    controlItemBgHover: colors.white3,
    controlItemBgActive: colors.white2,

    colorBorder: colors.white4,

    // borderRadius of e.g. dropdown menu
    borderRadiusLG: 4,
    fontSizeLG: 14,

    fontFamily:
      '-apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Fira Sans, Ubuntu, Oxygen, Oxygen Sans, Cantarell, Droid Sans, Apple Color Emoji, Segoe UI Emoji, Segoe UI Emoji, Segoe UI Symbol, Lucida Grande, Helvetica, Arial, sans-serif',

    motionDurationMid: '0.08s',
    motionDurationSlow: '0.16s',
  },
  components: {
    Button: {
      textHoverBg: colors.white2,
      contentFontSizeLG: 14,
    },
    Toast: {
      colorPrimary: colors.green4,
      algorithm: true,
    },
    Input: {
      hoverBg: colors.white1,
      hoverBorderColor: colors.white4,
    },
    Layout: {
      headerBg: colors.white2,
      lightSiderBg: colors.white1,
    },
    Menu: {
      itemHoverBg: colors.white2,
      itemSelectedBg: colors.white3,
      itemSelectedColor: colors.black4,
    },
    Table: {
      footerBg: colors.white1,
    },
    Steps: {},
  },
};
